export default {
  'Sample photo': 'サンプル写真',
  Removing: '除去中',
  Edit: '編集',
  'Adjust Picture': '写真の調整',
  Restore: '復元',
  Eraser: '消しゴム',
  Size: 'サイズ',
  Background: '背景',
  Custom: 'カスタム',
  Presets: 'プリセット',
  'Add Image': 'イメージの追加',
  'Scale to Fit': 'スケールのフィッティング',
  'Full Width': '全幅',
  'Full Height': '全高',
  Move: '移動',
  Undo: '取り消し',
  Redo: 'やり直し',
  Enlarge: '拡大する',
  Reduce: '縮小する',
  //2022.09.28 xxy
  BGRemover: {
    title: 'HitPawオンライン背景リムーバー',
    desc: '100%自動かつ無料で写真の背景を簡単に削除',
    imgAlt: 'photo background remover',
    submitBtn: '背景の除去',
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows" : "Shadow",
  "Intensity" : "Opacity",
  "Radius" : "Radius",
  "Color" : "Color",
  "Move" : "Move Shadow",
  "2D move" : "2D",
  "3D move" : "3D",
  "Move the shadow" : "Drag the shadow around in the image",
      "Upload failed, click to try again": "Upload failed, click to try again",
};
